module.exports = __webpack_public_path__ + "img/SourceHanSansCN-Regular.fc7081b7.svg";